export default theme => ({
  root: {
    fontSize: 16,
    color: theme.grey4,
    '&[data-is-error=true]': {
      color: 'red'
    }
  }
});
